<template>
  <div/>
</template>

<script>
import { Editor } from '@tiptap/vue-2'
import Link from '@tiptap/extension-link'
import Table from '@tiptap/extension-table'
import TableHeader from '@tiptap/extension-table-header'
import TableCell from '@tiptap/extension-table-cell'
import TableRow from '@tiptap/extension-table-row'
import Image from '@tiptap/extension-image'
import Media from '@/components/fields/wysiwyg/extensions/media'
import Subscript from '@tiptap/extension-subscript'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import _ from 'lodash'
import Underline from '@tiptap/extension-underline'
import BrezelLink from '@/components/fields/wysiwyg/extensions/brezel-link'
import NoLineSpacing from '@/components/fields/wysiwyg/extensions/no-line-spacing'
import Blockquote from '@tiptap/extension-blockquote'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import Code from '@tiptap/extension-code'
import CodeBlock from '@tiptap/extension-code-block'
import Document from '@tiptap/extension-document'
import HardBreak from '@tiptap/extension-hard-break'
import Heading from '@tiptap/extension-heading'
import HorizontalRule from '@tiptap/extension-horizontal-rule'
import ListItem from '@tiptap/extension-list-item'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Strike from '@tiptap/extension-strike'
import Dropcursor from '@tiptap/extension-dropcursor'
import Gapcursor from '@tiptap/extension-gapcursor'
import History from '@tiptap/extension-history'
import FontFamily from '@tiptap/extension-font-family'
import FontSize from 'tiptap-extension-font-size'

export default {
  name: 'EditorMixin',
  props: {},
  data () {
    return {
      editor: undefined,
      pasteWithStylesOverride: null,
    }
  },
  computed: {
    imageModule () {
      return this.$store.getters.getModuleByIdentifier(this.options.imageModule || 'files')
    },

    imageDirectory () {
      return this.options.imageDirectory || '/'
    },

    pasteWithStyles () {
      if (this.pasteWithStylesOverride !== null) {
        return this.pasteWithStylesOverride
      }
      return this.options.paste_with_styles ?? true
    },
  },
  created () {
    const editorExtensions = this.prepareExtensions()
    this.createEditor(editorExtensions, this.editable)
  },
  mounted () {
    this.$nextTick(function () {
      this.editor.storage.media.directory = _.get(this.field, 'options.imageDirectory', '/')
    })
  },
  methods: {
    prepareExtensions () {
      const imageModuleName = _.get(this.field, 'options.imageModule', 'files')
      const imageModule = this.$store.getters.getModuleByIdentifier(imageModuleName)
      const imageDirectory = _.get(this.field, 'options.imageDirectory', '/')

      const extensions = [
        Document,
        History,
        Text,
        Paragraph,
        Blockquote,
        OrderedList,
        BulletList,
        ListItem,
        CodeBlock,
        Code,
        HardBreak,
        Heading,
        HorizontalRule,
        Dropcursor,
        FontFamily,
        FontSize,
        Gapcursor,
        Link,
        Table,
        TableHeader,
        TableCell,
        TableRow,
        Image,
        Color,
        Bold,
        Italic,
        Strike,
        Highlight.configure({
          multicolor: true,
        }),
        BrezelLink,
        Media.extend({
          addOptions: {
            ...Media.options,
            module: imageModule,
            directory: imageDirectory,
          },
          addStorage () {
            return {
              directory: imageDirectory,
            }
          },
        }),
        Subscript,
        TextStyle,
        Underline,
      ]

      if (this.field.options && this.field.options.no_paragraphs) {
        extensions.push(NoLineSpacing)
      }

      return extensions
    },
    createEditor (extensions = [], editable = true) {
      const mixin = this
      this.editor = new Editor({
        useBuiltInExtensions: extensions === [],
        extensions: extensions,
        editable: editable,
        onUpdate: (state) => {
          this.out_value = this.editor.getHTML()
          this.updatedFromEditor = true
        },
        editorProps: {
          transformPastedHTML (html) {
            if (mixin.pasteWithStyles) {
              return html
            }
            // Remove all style attributes
            return html.replace(/(<[^>]+) style=['"].*?['"]/g, '$1')
          },
        },
      })
    },
  },
}
</script>

<style scoped>

</style>
